<template>
  <div>
    <OnboardingPopup />
  </div>
</template>

<script>
import OnboardingPopup from "../components/Onboarding/OnboardingPopup.vue";
export default {
  components: {
    OnboardingPopup
  }
};
</script>

<style lang="scss" scoped></style>
